__webpack_require__.p = "/jornadas-tecnologicas/";